<template>
    <div>
        <b-btn :id="id" class="btn btn-card-action btn-card-action-light my-1" @click="showDeleteModal = true">Удалить</b-btn>
        <b-modal v-model="showDeleteModal" title="Удалить закупку" @hide="onHide" centered no-close-on-backdrop no-close-on-esc>
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <p>Вы действительно хотите удалить закупку {{ contract.reg_number }}?</p>
            </div>
            <template #modal-footer>
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary"> <b-button variant="custom-outline-secondary" @click="onHide">Отмена </b-button>&nbsp; </b-overlay>
                <b-overlay :show="isLoading" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button variant="custom-danger" @click="onDelete">Подтвердить</b-button>
                </b-overlay>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'cabinet-fl44-external-purchase-delete-button',
    props: {
        contract: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showDeleteModal: false,
            isLoading: false
        };
    },
    methods: {
        onHide() {
            this.showDeleteModal = false;
        },
        async onDelete() {
            this.isDataSending = true;
            if (await this.$api.personal.fl44ExternalPurchases.deleteDraft(this.contract.id)) {
                this.showDeleteModal = false;
                this.refresh();
            }
            this.isDataSending = false;
        },
        refresh() {
            this.$emit('refresh');
        }
    },
    computed: {
        id() {
            return 'cabinet-fl44-external-purchase-delete-button-' + this._uid;
        }
    }
};
</script>
